
import React from 'react';
import {
  Dialog,
  Box,
  Typography
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import './FullScreenDiagram.css';

export default function FullScreenDiagram({
  open,
  onClose,
  children,
  chartType,
  period,
  isMobile,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: '96vw', md: '90vw' },
          height: { xs: '92vh', md: '90vh' },
          maxWidth: { xs: '96vw', md: '90vw' },
          maxHeight: { xs: '92vh', md: '90vh' },
          borderRadius: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          m: 0,
        },
      }}
    >
      <Box
        className="watermanagement-fullscreen-header"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: { xs: 55, sm: 0 },
          padding: { xs: '0 12px', sm: '22px' },
          flexShrink: 0,
          color: '#f3f3f3',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: 14, sm: 'inherit' },
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {chartType + " - " + period}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Box
            onClick={onClose}
            sx={{
              width: 28,
              height: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#f3f3f3',
              '&:hover': {
                backgroundColor: '#1586c3',
              },
            }}
          >
            <CloseRoundedIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          p: { xs: 1.5, md: 3 },
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          backgroundColor: '#ffffff',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </Dialog>
  );
}
